// components/Empty.tsx
import type { FC } from 'react';
import { Box, Stack, Text } from '@mantine/core';
import { IconMoodEmpty } from '@tabler/icons-react';

interface EmptyProps {
  height?: number;
  text?: string;
}

export const Empty: FC<EmptyProps> = ({ height = 400, text = 'No items found' }) => {
  return (
    <Box
      style={{
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack align="center" gap="md">
        <IconMoodEmpty size={64} opacity={0.5} />
        <Text size="lg" c="dimmed">
          {text}
        </Text>
      </Stack>
    </Box>
  );
};